import { EmpresaCgr } from 'src/app/domain/model/empresa/empresa-cgr';
import { OffsetPageResponse } from 'src/app/domain/model/common/offset-page-response.dto';

/**
 * Puerto de salida para búsqueda de empresas CGR.
 * Implementado por HttpEmpresaCgrRepository.
 *
 * Fuente: PCK_DIS_CONSULTA_LISTAS.SP_DIS_BUSCAR_EMPRESAS.
 * Diferente a BeneficiarioRepository (que usa TPSC_BENEFICIARIO).
 */
export abstract class EmpresaCgrRepository {
  abstract buscar(
    dni: string | null | undefined,
    nombre: string | null | undefined,
    pageNumber: number,
    pageSize: number
  ): Promise<OffsetPageResponse<EmpresaCgr>>;
}
